// src/store/actionTypes.js

export const GET_CLASSROOMS = 'GET_CLASSROOMS';
export const GOT_CLASSROOMS = 'GOT_CLASSROOMS';
export const FETCH_CLASSROOMS_ERROR = 'FETCH_CLASSROOMS_ERROR';


export const GET_MEDIA = 'GET_MEDIA';
export const GOT_MEDIA = 'GOT_MEDIA';
export const FETCH_MEDIA_ERROR = 'FETCH_MEDIA_ERROR';



export const GET_TRANSCRIPTION = 'GET_TRANSCRIPTION';
export const GOT_TRANSCRIPTION = 'GOT_TRANSCRIPTION';
export const FETCH_TRANSCRIPTION_ERROR = 'FETCH_TRANSCRIPTION_ERROR';

export const GET_OVERALL_DATA = 'GET_OVERALL_DATA';
export const GOT_OVERALL_DATA = 'GOT_OVERALL_DATA';
export const FETCH_OVERALL_DATA_ERROR = 'FETCH_OVERALL_DATA_ERROR';